const isWide = window.innerWidth > 490;

$('.slider-best').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  focusOnSelect: true,
  infinite: false,
  variableWidth: true,
  initialSlide: 0, 
  infinite: true,
  centerMode: isWide,           
  responsive: [
    {
      breakpoint: 490, 
      settings: {
        centerMode: false
      }
    },
    {
      breakpoint: 9999,
      settings: {
        centerMode: true
      }
    }
  ]
});
